/*
 * LanguageList Messages
 *
 * This contains all the text for the LanguageList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  en: {
    id: 'app.components.LanguageList.english',
    defaultMessage: 'English',
  },
  es: {
    id: 'app.components.LanguageList.spanish',
    defaultMessage: 'Español',
  },
  de: {
    id: 'app.components.LanguageList.german',
    defaultMessage: 'Deutsch',
  },
  nb: {
    id: 'app.components.LanguageList.norwegian',
    defaultMessage: 'Norsk bokmål',
  },
  ru: {
    id: 'app.components.LanguageList.russian',
    defaultMessage: 'Русский',
  },
  fr: {
    id: 'app.components.LanguageList.french',
    defaultMessage: 'Français',
  },
});
